export default "__VITE_ASSET__1yNM2sfA__"